import { Button } from "@material-ui/core";
import React, { useCallback, useState } from "react";
import { useHistory } from "react-router-dom";
import api from "../../api/api";

const AdminDashboard: React.FC<{}> = () => {
    const history = useHistory();
    const [backfillResult, setBackfillResult] = useState<string | null>(null);
    const [backfillLoading, setBackfillLoading] = useState(false);

    const handleForumsClicked = useCallback(() => {
        history.push("/admin/forums");
    }, [history]);

    const handleUsersClicked = useCallback(() => {
        history.push("/admin/users");
    }, [history]);

    const handleAnnouncementsClicked = useCallback(() => {
        history.push("/admin/announcements");
    }, [history]);

    const handleBackfillSlugs = useCallback(async () => {
        setBackfillLoading(true);
        setBackfillResult(null);
        try {
            const response = await api.post("ForumTopic/admin/backfill-slugs");
            const count: number = response.data;
            setBackfillResult(
                count === 0
                    ? "All topics already have a slug — nothing to update."
                    : `Successfully generated slugs for ${count} topic${count !== 1 ? "s" : ""}.`,
            );
        } catch {
            setBackfillResult("An error occurred while backfilling slugs.");
        } finally {
            setBackfillLoading(false);
        }
    }, []);

    return (
        <div id="admin" className="w-100 px-2">
            <div className="box-shadow">
                <div className="title-bar px-2">Admin Home</div>
                <div className="bg-light-gray p-2 bl-xs br-xs bb-xs d-flex flex-column">
                    <div className="vert-row row">
                        <div className="vert-col col-12 col-lg-6">
                            <Button
                                variant="contained"
                                className="d-flex justify-content-between dark-red-button admin-button rounded-0 w-100"
                                onClick={handleForumsClicked}
                            >
                                <i className="admin-button-icon mr-3 fas fa-project-diagram"></i>
                                <span className="text-normal">
                                    Manage the forums, categories and threads
                                </span>
                            </Button>
                        </div>
                        <div className="vert-col col-12 col-lg-6">
                            <Button
                                variant="contained"
                                className="d-flex justify-content-between dark-red-button admin-button rounded-0 w-100"
                                onClick={handleUsersClicked}
                            >
                                <i className="admin-button-icon mr-3 fas fa-users"></i>
                                <span className="text-normal">
                                    Manage the forum users and groups
                                </span>
                            </Button>
                        </div>
                        <div className="vert-col col-12 col-lg-6">
                            <Button
                                variant="contained"
                                className="d-flex justify-content-between dark-red-button admin-button rounded-0 w-100"
                                onClick={handleAnnouncementsClicked}
                            >
                                <i className="admin-button-icon mr-3 fas fa-bullhorn"></i>
                                <span className="text-normal">
                                    Manage the announcements
                                </span>
                            </Button>
                        </div>
                    </div>

                    <hr />

                    <div className="vert-row row">
                        <div className="vert-col col-12">
                            <p className="mb-1">
                                <strong>Maintenance</strong>
                            </p>
                        </div>
                        <div className="vert-col col-12 col-lg-6">
                            <Button
                                variant="contained"
                                className="d-flex justify-content-between dark-red-button admin-button rounded-0 w-100"
                                onClick={handleBackfillSlugs}
                                disabled={backfillLoading}
                            >
                                <i className="admin-button-icon mr-3 fas fa-link"></i>
                                <span className="text-normal">
                                    {backfillLoading
                                        ? "Generating slugs…"
                                        : "Backfill missing forum topic slugs"}
                                </span>
                            </Button>
                            {backfillResult && (
                                <p className="mt-1 mb-0 small">
                                    {backfillResult}
                                </p>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AdminDashboard;
